import ApolloClient from 'apollo-client';
import { useMemo } from 'react';
import { ApolloLink } from 'apollo-link';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createUploadLink } from 'apollo-upload-client';
import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';
import _ from 'lodash';

const create = (token, onUnauthorizedError) => {
  const authorizationHeader = token && { 'meteor-login-token': token };
  const authLink = setContext((__, { headers }) => ({
    headers: {
      ...headers,
      ...authorizationHeader,
    },
  }));
  const uploadLink = createUploadLink({
    uri: process.env.REACT_APP_GRAPHQL_URI, // Apollo Server is served from port 4000
    headers: {
      'keep-alive': 'true',
      ...authorizationHeader,
    },
  });

  return new ApolloClient({
    uri: process.env.REACT_APP_GRAPHQL_URI,
    link: ApolloLink.from([onError(({
      graphQLErrors, networkError, operation,
    }) => {
      if (graphQLErrors) {
        graphQLErrors.forEach(({ message, locations, path }) => {
          // eslint-disable-next-line no-console
          console.error(`[GraphQL error]: ${message}`, {
            locations,
            operationName: operation && operation.operationName,
            path,
          });
        });
      }
      if (networkError) {
        const errorCode = networkError.response && networkError.response.status;
        if (errorCode === 401) {
          onUnauthorizedError(networkError);
        } else {
          console.error('network error when fetching', networkError);
        }
      }
    }), authLink, uploadLink]),
    cache: new InMemoryCache({
      addTypename: false,
    }),
  });
};

// eslint-disable-next-line react-hooks/exhaustive-deps
export default ({ onUnauthorizedError, token }) => useMemo(() => create(_.isEmpty(token) ? undefined : token, onUnauthorizedError), [token]);
